import * as Sentry from "@sentry/browser";
import Push from "push.js";

import { BRAND_INFO } from "../config/urls";
import { webNotification } from "../assets/audio";

const audio = new Audio(webNotification);
audio.muted = true;

const blankFunction = () => {}; //Browser handles everything itself

const sendPushNotification = ({ icon, body } = {}) => {
  if (Push.Permission.has() && body) {
    const options = {
      icon,
      link: 'chats',
      tag: new Date(),
      vibrate: [200, 100, 200],
      body: `${body} ${new Date().toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
      })}`,
      timeout: 2000,
      onShow: function() {
        try {
          if (audio && audio.paused) {
            let promise = audio.play();
            promise.catch(blankFunction);
            if (promise !== undefined) {
              audio
                .play()
                .then(() => {
                  audio.muted = false;
                })
                .catch(blankFunction);
            }
          }
        } catch (error) {
          Sentry.captureException(error);
        }
      },
      onClick: function() {
        window.focus();
        this.close();
      }
    };
    Push.create(BRAND_INFO.notification_header, options);
  }
};

export { sendPushNotification };



// WEBPACK FOOTER //
// ./src/data/notification/pushNotification.js